const isEmptyValue = (value: unknown) =>
  value === null ||
  value === undefined ||
  value === '' ||
  (Array.isArray(value) && value.length === 0)

export const mapObjectPropertyEmptyToNull = (
  emptyOrNonEmptyObject: Record<string, unknown>
) => {
  const returnObjectWithNull: Record<string, unknown> = {}
  Object.keys(emptyOrNonEmptyObject).forEach(objKey => {
    returnObjectWithNull[objKey] = isEmptyValue(emptyOrNonEmptyObject[objKey])
      ? null
      : emptyOrNonEmptyObject[objKey]
  })
  return returnObjectWithNull
}
